// Section 19: the event catalog (22 events). EventId is derived from config.events.
// Adding an event: a file here, a line below, and its constants under config.events.
import type { Config } from '../../config';
import { checkRegistryKeys, type EventDef } from '../../core/registry';
import type { EventId } from '../../core/types';
import { birthComplication } from './birth-complication';
import { blight } from './blight';
import { discovery } from './discovery';
import { dispute } from './dispute';
import { drought } from './drought';
import { earlyFrost } from './early-frost';
import { eldersRequest } from './elders-request';
import { feverOutbreak } from './fever-outbreak';
import { fire } from './fire';
import { goodHarvest } from './good-harvest';
import { harshWinter } from './harsh-winter';
import { improvementProposal } from './improvement-proposal';
import { mildWinter } from './mild-winter';
import { plague } from './plague';
import { poorHarvest } from './poor-harvest';
import { raid } from './raid';
import { refugees } from './refugees';
import { rumour } from './rumour';
import { stranger } from './stranger';
import { tradeCaravan } from './trade-caravan';
import { travellers } from './travellers';
import { wildAnimals } from './wild-animals';

/** Build the events registry for a config (content numbers come from the config, ADR-0008). */
export function buildEvents(config: Config) {
  const events = Object.freeze({
    'poor-harvest': poorHarvest(config),
    blight: blight(config),
    drought: drought(config),
    'harsh-winter': harshWinter(config),
    'early-frost': earlyFrost(config),
    fire: fire(config),
    'fever-outbreak': feverOutbreak(config),
    plague: plague(config),
    'wild-animals': wildAnimals(config),
    raid: raid(config),
    refugees: refugees(config),
    travellers: travellers(config),
    'trade-caravan': tradeCaravan(config),
    'good-harvest': goodHarvest(config),
    'mild-winter': mildWinter(config),
    discovery: discovery(config),
    'improvement-proposal': improvementProposal(config),
    dispute: dispute(config),
    'elders-request': eldersRequest(config),
    'birth-complication': birthComplication(config),
    stranger: stranger(config),
    rumour: rumour(config),
  } satisfies Record<EventId, EventDef>);
  checkRegistryKeys('events', events);
  return events;
}
